interface ParticipantCounts {
  respondentCount: number;
  audienceMemberCount: number;
}

export function getVisibleAudienceMemberCount(
  input: ParticipantCounts,
): number {
  const rawAudience = isNaN(input.audienceMemberCount)
    ? 0
    : input.audienceMemberCount;

  // Ensure displayed audience count is never less than respondent count
  return Math.max(rawAudience, input.respondentCount);
}
